import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import firebase from "../../../lib/firebase";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import { isLoginStatusLoading, isUserLoggedIn } from "../../../state/user";
import { useSelector } from "react-redux";
import Loader from "../../atomic/Loader/Loader";
import Layout from "../../containers/Layout/Layout";

const qs = require("query-string");

export const LoginPage = ({ location }) => {
  const [redirectLocation, setRedirectLocation] = useState("/");
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });
  useEffect(() =>
    setRedirectLocation(
      query.redirectto
        ? query.redirectto
        : location.state
        ? location.state.from || "/"
        : "/"
    )
  );
  console.log("Redirect location", redirectLocation);
  const isLoading = useSelector(state => isLoginStatusLoading(state));
  const loggedIn = useSelector(state => isUserLoggedIn(state));
  if (loggedIn) {
    return <Redirect to={redirectLocation} />;
  }

  var uiConfig = {
    //signInFlow: "popup",
    signInSuccessUrl: "/login?redirectto=" + redirectLocation,
    signInOptions: [
      // Leave the lines as is for the providers you want to offer your users.
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      firebase.auth.FacebookAuthProvider.PROVIDER_ID,
      firebase.auth.EmailAuthProvider.PROVIDER_ID
    ],
    // tosUrl and privacyPolicyUrl accept either url string or a callback
    // function.
    // Terms of service url/callback.
    tosUrl: "https://kidsqualitytime.com/terms.html",
    // Privacy policy url/callback.
    privacyPolicyUrl: "https://kidsqualitytime.com/privacy.html"
  };
  return (
    <div className="login-my" style={{ paddingTop: "50px" }}>
      {isLoading && <Loader />}
      {!isLoading && (
        <StyledFirebaseAuth
          uiConfig={uiConfig}
          firebaseAuth={firebase.auth()}
        />
      )}
    </div>
  );
};
